import {
    useState
} from 'react';

const MAX_FILES = 3;
const MAX_BYTES = 5 * 1024 * 1024; // 5MB

/**
 * useAttachments — composer attachments for BEXI (images + PDF, max 3, 5MB).
 * Files are read to data URLs in the browser; the panel sends them with the turn.
 */
export function useAttachments() {
    const [attachments, setAttachments] = useState([]);

    const addFiles = (fileList) => {
        const files = Array.from(fileList || []);
        setAttachments((prev) => {
            const next = [...prev];
            for (const f of files) {
                if (next.length >= MAX_FILES) break;
                if (f.size > MAX_BYTES) continue;
                const isImg = f.type.startsWith('image/');
                const isPdf = f.type === 'application/pdf';
                if (!isImg && !isPdf) continue;
                const entry = {
                    name: f.name,
                    type: isImg ? 'image' : 'pdf',
                    reading: true,
                    dataUrl: ''
                };
                next.push(entry);
                const reader = new FileReader();
                reader.onload = () => setAttachments((cur) => cur.map((a) => (a === entry ? {
                    ...a,
                    dataUrl: reader.result,
                    reading: false
                } : a)));
                reader.onerror = () => setAttachments((cur) => cur.filter((a) => a !== entry));
                reader.readAsDataURL(f);
            }
            return next;
        });
    };

    const removeAttachment = (i) => setAttachments((prev) => prev.filter((_, idx) => idx !== i));
    const clear = () => setAttachments([]);

    return {
        attachments,
        addFiles,
        removeAttachment,
        clear,
    };
}
